import { GET } from 'helpers/api'

// A4 chek pastidagi eslatma matni. Ikki xil:
//   - sales      -> sotuv bo'limi (owner/director/kassir)
//   - production -> ishlab chiqarish rollari (usta/omborchi/ishlab chiqarish rahbari)
// Matn owner tomonidan "Nastroyka > A4 chek matni" da kiritiladi va bazada saqlanadi.

// Ishlab chiqarish rollari — bularга production matni ko'rsatiladi
const PRODUCTION_ROLES = ['ROLE_WORKSHOP', 'ROLE_WAREHOUSE', 'ROLE_PROD_MANAGER']

// Owner hech narsa kiritmagan bo'lsa ishlatiladigan standart sotuv matni (eski qattiq-kod matn)
const DEFAULT_SALES = "! Hurmatlik Mijoz buyurtmangizni rasmiylashtirib bo'lganingizdan so'ng mahsulotlarning o'lchamlari, soni, rangi va yetkazib berish vaqtlari to'g'ri kiritilganini tekshirib chiqib bo'libgina imzo qo'yib sotuvchiga topshiring!"

const STORAGE_KEY = 'cheque_notes'

// Bir sessiyada bir marta yuklanadi (localStorage bilan birga)
let cache = null

export function isProductionRole(role) {
	return PRODUCTION_ROLES.includes(role)
}

// localStorage'dan sinxron o'qish (print vaqtida poyga bo'lmasin uchun)
function readCache() {
	if (cache) return cache
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (raw) {
			cache = JSON.parse(raw)
			return cache
		}
	} catch (e) { /* jim */ }
	return null
}

function writeCache(sales, production) {
	cache = { sales: sales || '', production: production || '' }
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(cache))
	} catch (e) { /* jim */ }
	return cache
}

// Bazadan yuklab, cache va localStorage'ni yangilaydi.
// Login.js dan (barcha rol uchun) va ChequeA4 dan (fon yangilash) chaqiriladi.
export async function loadChequeNotes() {
	try {
		const res = await GET('/cheque-note-settings', {}, { loader: false })
		if (res && res.status >= 200 && res.status < 300) {
			return writeCache(res.data?.note_sales, res.data?.note_production)
		}
	} catch (e) { /* jim */ }
	return cache
}

// Rolga qarab kerakli matnni sinxron qaytaradi (print uchun).
// production matni bo'sh bo'lsa -> sotuv matniga tushadi (bo'sh joy chiqmasin).
export function getChequeNote(role) {
	const c = readCache() || {}
	const sales = c.sales || DEFAULT_SALES
	if (isProductionRole(role)) {
		return c.production || sales
	}
	return sales
}
